module.exports = function(h, row) {
    return <span class="_500">{row.quantity}</span>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock/inventory-quantity.jsx